import { ContextModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React, { SyntheticEvent } from "react";
import { MdCancel } from "react-icons/md";

type PROPS = {
  data?: CommonFileModel[];
  previewWidth?: string;
  previewHeight?: string;
  ctx?: ContextModel;
  name?: string;
  maxSize?: number;
  withNew?: boolean;
};

const SubImageForm: React.FC<PROPS> = (props) => {
  const ref = React.useRef<HTMLInputElement>(null);

  const [fileName] = React.useState("");
  const [data, setData] = React.useState<CommonFileModel[]>([]);

  const onClick = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const addImage = (e: SyntheticEvent) => {
    const fileReader = new FileReader();
    const target = e.target as HTMLInputElement;
    const files = target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (props.maxSize) {
        const max = props.maxSize * 1024 * 1024;
        const _ = `fileSize:${file.size}\n     max:${max}`;
        if (file.size > max) {
          console.log(`[File Size NG]\n${_}`);
          if (props.ctx) {
            props.ctx.msgDialog.setState({
              message: props.name
                ? `${props.name}は最大${props.maxSize}MBまで登録可能です。`
                : `${props.maxSize}MBまで登録可能です。`,
            });
          }
          if (ref.current) {
            ref.current.value = "";
          }
          return;
        } else {
          console.log(`[File Size OK]\n${_}`);
        }
      }

      fileReader.readAsDataURL(files[0]);
      fileReader.onload = (e) => {
        const target = e.target;
        if (target) {
          const file_name = files[0].name;
          const file_data = target.result as string;
          if (props.data) {
            props.data.push({
              file_name,
              file_data: file_data,
              image_url: "",
              is_new: props.withNew
            });
            setData([...props.data]);
          }
          // console.log(JSON.stringify(props.data));
          // setFileName(file_name);
        }
        if (ref.current) {
          ref.current.value = "";
        }
      };
    }
  };

  const clearPreview = (target: CommonFileModel) => {
    const idx = data.indexOf(target);
    data.splice(idx, 1);
    const tmp = [...data];
    setData(tmp);
    if (props.data) {
      while (props.data.length) {
        props.data.pop();
      }
      props.data.push(...tmp);
    }
  };

  const previewWidth = props.previewWidth ?? "200px";
  const previewHeight = props.previewHeight ?? "200px";

  React.useEffect(() => {
    const data = props.data;
    if (data) {
      setData([...data]);
    } else {
      setData([]);
    }
  }, [props.data]);

  return (
    <div className="flex flex-col">
      <input
        hidden
        type="file"
        accept="image/*"
        onChange={addImage}
        ref={ref}
      />
      <div className="flex items-center gap-4">
        <button
           className={`${data.length >= 10 ? 'secondary-disabled px-4 py-2 ' : 'secondary px-4 py-2 '}`}
          onClick={onClick}
          disabled={data.length >= 10}
        >
          ファイル選択
        </button>
        <span>{fileName}</span>
      </div>

      <div className="my-2 flex flex-wrap">
        {data.map((v, i) => {
          let src = "";
          if (v.file_data) {
            src = v.file_data;
          } else if (v.image_url) {
            src = v.image_url;
          } else if (v.image_data) {
            src = v.image_data;
          }

          return (
            <div key={i} className="max-w-[20%]">
              <div className="m-2">
                <div className="relative border rounded-sm">
                  <img
                    src={src}
                    alt=""
                    style={{
                      width: previewWidth,
                      height: previewHeight,
                      objectFit: "contain",
                    }}
                  />
                  <div className="text-right text-sm text-gray-400 overflow-hidden text-ellipsis">
                    {v.file_name}
                  </div>
                  <div
                    className="absolute top-0 right-0"
                    style={{ transform: "translate(10px, -10px)" }}
                  >
                    <button
                      onClick={() => {
                        clearPreview(v);
                      }}
                    >
                      <MdCancel className="text-3xl" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubImageForm;
